import {
  ConfirmDialog,
  DatePick,
  Pick,
  DateRangeInput,
  type IsoDate,
  type Option,
  type DateRange,
} from '@trippath/shared';
import { useState } from 'react';

type Mode = 'flight' | 'train' | 'bus' | 'ferry';

const modes: Option<Mode>[] = [
  { value: 'flight', label: 'Flight' },
  { value: 'train', label: 'Train' },
  { value: 'bus', label: 'Bus' },
  { value: 'ferry', label: 'Ferry' },
];

/**
 * Every shared control on one page (`/kit`): the living style guide, and what Playwright drives
 * in a real browser (e2e/kit.spec.ts). Not linked from the app.
 */
export function Kit() {
  const [day, setDay] = useState<IsoDate | null>('2026-10-18');
  const [trip, setTrip] = useState<DateRange>({ from: '2026-10-18', to: '2027-02-07' });
  const [mode, setMode] = useState<Mode | null>('flight');
  const [asking, setAsking] = useState(false);
  const [answer, setAnswer] = useState('none');

  return (
    <div className="page kit">
      <h1>Components</h1>
      <section className="kit-grid">
        <div>
          <DatePick label="Leave on" value={day} onChange={setDay} />
          <output data-testid="day">{day ?? 'none'}</output>
        </div>
        <div>
          <DateRangeInput label="Trip" value={trip} onChange={setTrip} />
          <output data-testid="trip">
            {[trip.from, trip.to].map((end) => end ?? '-').join(' ')}
          </output>
        </div>
        <div>
          <Pick
            label="Transport"
            options={modes}
            value={mode}
            onChange={setMode}
            onClear={() => {
              setMode(null);
            }}
          />
          <output data-testid="mode">{mode ?? 'none'}</output>
        </div>
        <div>
          <button
            type="button"
            className="button"
            onClick={() => {
              setAsking(true);
            }}
          >
            Delete photo…
          </button>
          <output data-testid="answer">{answer}</output>
        </div>
      </section>
      <ConfirmDialog
        open={asking}
        title="Delete the photo?"
        body="The expense stays, marked as having no photo."
        confirmLabel="Delete"
        onConfirm={() => {
          setAnswer('deleted');
          setAsking(false);
        }}
        onCancel={() => {
          setAnswer('kept');
          setAsking(false);
        }}
      />
    </div>
  );
}
